/** マイページメニュー等と同一のプライバシーポリシー URL */
export const PRIVACY_POLICY_URL =
  "https://www.notion.so/396fccb1feeb468ba2b608e267688875?pvs=4";
